function announcementFixed() {
  const targetElement = document.querySelector('.c-announcement-bar__wrapper'),
        header = document.querySelector('.c-header'),
        body = document.querySelector('body'),
        mainVisual = document.querySelector('.c-mainvisual__section'),
        threshold = window.innerHeight - header.clientHeight - targetElement.clientHeight;

  // アナウンスバー可変値に備えたメインビジュアル高さの動的調整
  if(mainVisual) {
    mainVisual.style.setProperty('--mv-desktop-height', `calc(100svh - ${header.clientHeight}px - ${targetElement.clientHeight}px)`);
    mainVisual.style.setProperty('--mv-mobile-height', `calc(100svh - ${targetElement.clientHeight}px`);
  }

  // 768px以下の場合は固定を解除して終了
  if (window.innerWidth <= 768) {
    body.classList.remove('scrolled-fv');
    targetElement.classList.remove('is-fixed');
    return;
  }

  window.addEventListener('scroll', function () {
    // スクロール時にも画面幅を再チェック
    if (window.innerWidth <= 768) {
      body.classList.remove('scrolled-fv');
      targetElement.classList.remove('is-fixed');
      return;
    }

    if (window.scrollY > threshold) {
      body.classList.add('scrolled-fv');
      targetElement.classList.add('is-fixed');
    } else {
      body.classList.remove('scrolled-fv');
      targetElement.classList.remove('is-fixed');
    }
  });
}

window.addEventListener('DOMContentLoaded', function () {
  announcementFixed();
});

window.addEventListener('resize', function () {
  announcementFixed();
});